import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
//import { Configuration } from 'src/app/Utilities/configurations';
//var Configuration = require('src/assets/app-config.json');
import { IUserDetails } from 'src/app/models/IUsersDetails';
import { configuration } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class ORNoteCommonService {

  constructor(private http: HttpClient) { }
  UserSigById(providerId: string, securityCode: string): Observable<IUserDetails> {
    return this.http.get<IUserDetails>
      (`${configuration.apiUrl + 'Admin/UserSigById'}?userid=${providerId}&&securityCode=${securityCode}&&facility=${sessionStorage.getItem("FacilityId")}`);

  }
}